import React, { PropsWithChildren, useCallback } from 'react';
import {
  IconButton,
  Icon,
  ListItemIcon,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  SupervisedUserCircle,
  AccountCircle,
  MoreVert,
  Add
} from '@mui/icons-material';
import { AddChannelButton } from './AddChannelButton';

import { useWorkspaceController, Workspace } from '../../context/WorkspaceController';
import { useChatContext } from 'stream-chat-react';

type ChannelListProps = PropsWithChildren<{
  error?: boolean;
  loading?: boolean;
  type: 'team' | 'messaging';
  fullScreen?: boolean;
}>;

const ChannelList = ({
  children,
  error = false,
  loading = false,
  type,
  fullScreen = false,
}: ChannelListProps) => {

  const { displayWorkspace } = useWorkspaceController();
  const {
    setActiveChannel,
  } = useChatContext();

  const [open, setOpen] = React.useState(false);
  const [element, setElement] = React.useState<HTMLElement | null>(null);

  const handleAddChannelClick = useCallback((channelType: ChannelListProps['type']) => {
    if (channelType === 'team') {
      displayWorkspace('Admin-Channel-Create__team');
    } else {
      displayWorkspace('Admin-Channel-Create__messaging');
    }
  }, [displayWorkspace]);

  if (error) {
    return type === 'team' ? (
      <div className='team-channel-list'>
        <p className='team-channel-list__message'>
          Connection error, please wait a moment and try again.
        </p>
      </div>
    ) : null;
  }

  if (loading) {
    return (
      <div className='team-channel-list'>
        <p className='team-channel-list__message loading'>
          {type === 'team' ? 'Channels' : 'Messages'} loading....
        </p>
      </div>
    );
  }

  return (
    <div className='team-channel-list'>
      <div className='team-channel-list__header'>
        { !fullScreen && (
          <p className='team-channel-list__header__title'>
            Channels and Messages
          </p>
        )}
        { !fullScreen && (
          <IconButton onClick={(e) => { setElement(e.currentTarget); setOpen(true); }}>
            <Add color="secondary" />
          </IconButton>
        )}
        <Menu
          id="menu-appbar"
          anchorEl={element}
          open={open}
          onClose={() => { setElement(null); setOpen(false); }}
        >
          <MenuItem
            onClick={() => {
              setElement(null);
              setOpen(false);
              setActiveChannel(null);
              handleAddChannelClick('team');
            }}
          >
            <ListItemIcon>
              <SupervisedUserCircle />
            </ListItemIcon>
            Create Chat Group
          </MenuItem>
        </Menu>
      </div>
      {children}
    </div>
  );
};

export const TeamChannelList = React.memo(ChannelList);
